/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Liczba dostępów',
    BLACK_FRIDAY_COMISSION_TITLE: 'Prowizje z okazji Czarnego Piątku {0}',
    BLACK_FRIDAY_COMMISSION: 'Prowizje z okazji Czarnego Piątku {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Prowizje z okazji Czarnego Piątku {0}',
    COMISSION_DESCRIPTION: 'Suma obliczona w bieżącym miesiącu:',
    COMISSION_LAST_MONTH: 'Homologiczny',
    COMISSION_LAST_TEN: 'Ostatnie {0} dni',
    COMISSION_TITLE: 'Prowizje {0} dni:',
    COMMISSION: 'Komisja',
    COMMISSION_COLUMN: 'Prowizja (€)',
    DAILY: 'Pamiętnik',
    DATE: 'Data',
    FEMALE: 'Kobieta',
    FIFTY_DAYS: '50 dni',
    GENDER: 'Płeć',
    HITS: 'Dostęp {0} dni:',
    HITS_DESCRIPTION: 'Dostęp',
    HOMOLOGOUS: 'Homologiczny',
    HOMOLOGOUS_LAST_YEAR: 'Poprzedni rok',
    MALE: 'Mężczyzna',
    NAME: 'Nazwa',
    NEW_CUSTOMERS: 'Nowe konta klientów {0} dni:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Nowe rocznicowe konta klientów Prozis',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Nowe konta oczekujące na zamówienie {0} dni:',
    NO_SALES: 'Brak sprzedaży',
    ORDER_PENDING_CUSTOMERS: 'Konto oczekujące na realizację',
    ORDERED_CUSTOMERS: 'Konto nowego klienta',
    ORDERS: 'Zamówienia {0} dni:',
    ORDERS_DESCRIPTION: 'Opłacone w ciągu ostatnich 6 miesięcy',
    ORDERS_DETAIL_DESCRIPTION: 'Opłaty oczekujące na płatność {0} dni:',
    ORDERS_PAY: 'Opłaty zapłacone',
    ORDERS_PENDING: 'Nieuregulowane opłaty',
    PERCENTAGE: 'Procent',
    PRODUCT_CATEGORY: 'Hierarchia',
    PRODUCT_COLUMN: 'Produkt',
    QT_COLUMN: 'Ilość',
    QUANTITY: 'Ilość',
    SALES: 'Sprzedaż',
    SALES_DESCRIPTION: 'Bieżący miesiąc',
    SALES_PRODUCT: 'Sprzedaż według hierarchii produktów',
    TEN_DAYS: '10 dni',
    THIRTEEN_DAYS: '30 dni',
    TOP_COMMISSION_TITLE: 'Najlepsze zamówione produkty',
    TOP_DESCRIPTION: 'Bieżący miesiąc',
    TOP_GENDER_DESCRIPTION: 'Ostatnie {0} dni',
    TOP_GENDER_TITLE: 'Najlepsza sprzedaż według płci',
    TOP_TITLE: 'Najlepiej sprzedające się artykuły',
    TWENTY_DAYS: '20 dni',
    UPDATED_AT: 'Aktualizacja {0}',
    VALUE: 'Wartość'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Brak danych',
    EMPTY_TITLE: 'Brak wyników'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
